<template>
  <div class="card mg-b-10 bd-0">
    <div class="card-header d-flex align-items-center justify-content-between bg-light">
      <h6 class="mg-b-0">
        {{ b != undefined && b.nm != undefined ? b.nm : "" }}
      </h6>
    </div>
    <div class="row">
      <div class="col-4" v-for="(t, i) in tasks"
        :key="i">
        <div @click="$emit('on-detail', t)" class="card" role="button">
          <img src="https://res.gosmart.mn/media/bg/forum.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h6 class="card-title">{{ t.task }}</h6>
            <div class="bd-2 bd-l pd-l-5">{{ t.i1 }} сэдэв</div>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
    </div>
    
    <!-- <ul class="list-group list-group-flush">
      <li
        @click="$emit('on-detail', t)"
        class="list-group-item d-flex align-items-center bd-0"
        v-for="(t, i) in tasks"
        :key="i"
        role="button"
      >
        <div class="avatar d-none d-sm-block">
          <span :class="`avatar-initial rounded-circle bg-teal`">
            <i class="icon ion-md-list"></i>
          </span>
        </div>
        <div class="pd-l-10">
          <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
        </div>
        <div class="mg-l-auto text-right">
          <p class="tx-medium text-info font-weight-bold mg-b-0">{{ t.i1 }}</p>
          <small class="tx-12 mg-b-0">сэдэв</small>
        </div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    b: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
